import { render, staticRenderFns } from "./Staffportal.vue?vue&type=template&id=a29201e8"
import script from "./Staffportal.vue?vue&type=script&lang=js"
export * from "./Staffportal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports